let lastScrollTop = 0;
const header = document.querySelector(".header-wrapper");
const announcementBar = document.getElementById("animatedText");
const banner = document.querySelector(".hz__hph-content-wrapper");
// Throttle scroll event handling for performance
let isScrolling = false;

window.addEventListener("scroll", function () {
  let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let isMobile = window.innerWidth <= 428;
  let isSmallScreen = window.innerWidth <= 749;

  let headerTopDesktop = "45.19px";
  let headerTopMobile = "50.19px";
  let headerTopSmallScreen = "50.19px";
  let hideHeader = isMobile ? "-65.19px" : "-201.88px";
  let hideAnnouncement = isSmallScreen
    ? "-50.19px"
    : isMobile
    ? "-50.19px"
    : "-45.19px";

  // Calculate the navbar height to determine when to hide
  let navbarHeight = isMobile ? 50.19 : 201.88; // Adjust based on the device

  // When scrolling down and past the navbar
  if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
    // Hide both header and announcement bar by sliding them up
    header.style.top = hideHeader; // Hide header
    announcementBar.style.top = hideAnnouncement; // Hide announcement bar
  }
  // When scrolling up
  else if (scrollTop < lastScrollTop) {
    // Show the header at the top of the page when scrolling up
    header.style.top = "0"; // Show header at the top

    // Show announcement bar only when at the top of the page
    if (scrollTop <= 0) {
      announcementBar.style.top = "0"; // Show announcement bar at the top
      header.style.top = isMobile
        ? headerTopMobile
        : isSmallScreen
        ? headerTopSmallScreen
        : headerTopDesktop;
    } else {
      // Hide announcement bar when not at the top
      announcementBar.style.top = hideAnnouncement; // Hide announcement bar
    }
    header.classList.remove("hidden");
  }

  lastScrollTop = scrollTop; // Update last scroll position

  // if (!isScrolling) {
  //   isScrolling = true;
  //   setTimeout(() => {
  //     handleHeaderVisibility();
  //     isScrolling = false;
  //   }, 100);
  // }
});

// Run once on DOMContentLoaded
// document.addEventListener("DOMContentLoaded", () => {
//   handleHeaderVisibility();
// });

// Function to toggle the header’s hidden class based on scroll position
// function handleHeaderVisibility() {
//   const header = document.querySelector("header");
//   const announcementBar = document.getElementById("animatedText");

//   if (!header || !announcementBar) return;

//   // Get heights (these could be refined or made fixed if known)
//   const headerHeight = header.offsetHeight;
//   const announcementHeight = announcementBar.offsetHeight;
//   const totalHeight = headerHeight + announcementHeight;
//   const scrollThreshold = totalHeight * 2; // for example, twice the total height

//   if (window.scrollY > scrollThreshold) {
//     header.classList.add("hidden");
//     alert("hi");
//   } else {
//     header.classList.remove("hidden");
//   }
// }
